import {
  PremiumPubTournamentsHeader,
  PremiumPubTournamentsWrapper,
} from "./style";
import { PubSkeletonWhiteBox } from "../../style/skeleton";
import PremiumPubTournamentItemSkeleton from "./components/tournament-item/skeleton";
import { SwiperSlide, Swiper } from "swiper/react";

const PremiumPubTournamentsSkeleton = () => {
  return (
    <PremiumPubTournamentsWrapper>
      <PremiumPubTournamentsHeader>
        <PubSkeletonWhiteBox height="24px" width="110px" />
        <PubSkeletonWhiteBox height="14px" width="65px" />
      </PremiumPubTournamentsHeader>
      <Swiper
        className="swiper"
        slidesPerView={1.1}
        centeredSlides={false}
        spaceBetween={12}
      >
        {Array.from({ length: 2 }, (_, index) => (
          <SwiperSlide key={index}>
            <PremiumPubTournamentItemSkeleton />
          </SwiperSlide>
        ))}
      </Swiper>
    </PremiumPubTournamentsWrapper>
  );
};
export default PremiumPubTournamentsSkeleton;
